<template>
  <section>
    <v-toolbar class="mb-0">
      <v-progress-linear
        v-if="false"
        absolute
        top
        indeterminate
        color="primary"
        height="7"
      ></v-progress-linear>
      <v-toolbar-title class="headline d-flex">
        <v-icon class="pr-2 align-self-center" color="grey" large
          >mdi-map</v-icon
        >
        <span class="align-self-center">{{ botName | upper_case }} <span class="font-weight-thin">Map</span></span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <div class="mr-4 pt-1" v-if="dateFilter" key="dateFilter"><b>From:</b> {{ dateFilter }}</div>
      <v-menu
        ref="datePicker"
        class="d-flex"
        v-model="datePicker"
        :close-on-content-click="false"
        :return-value.sync="dateFilter"
        transition="scale-transition"
        offset-y
        min-width="250px"
      >
        <template v-slot:activator="{ on }">
          <v-btn :color="dateFilter ? 'primary' : ''" icon v-on="on">
            <v-icon>mdi-calendar</v-icon>
          </v-btn>
        </template>
        <v-date-picker v-model="dateFilter" no-title scrollable>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="dateFilter = null"
            >Clear</v-btn
          >
          <v-btn text color="primary" @click="$refs.datePicker.save(dateFilter)"
            >OK</v-btn
          >
        </v-date-picker>
      </v-menu>
      <v-menu
        bottom
        left
        :close-on-click="true || !actionLayers || !actionLayers.length"
        :close-on-content-click="false"
        :offset-y="false"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            :color="actionLayers && actionLayers.length ? 'primary' : ''"
            icon
            v-on="on"
          >
            <v-icon>mdi-filter</v-icon>
          </v-btn>
        </template>
        <v-toolbar flat dense :min-width="400" :max-width="500">
          <v-select
            v-model="actionLayers"
            :items="actions"
            item-text="name"
            item-value="id"
            label="Action Layers"
            class="map-filter"
            validate-on-blur
            multiple
          >
            <template v-slot:selection="{ index }">
              <span
                v-if="index === 0 && actionLayers && actionLayers.length"
                class="grey--text caption"
              >
                ({{ actionLayers.length }} Action Types)
              </span>
            </template>
          </v-select>
        </v-toolbar>
      </v-menu>
      <v-menu
        bottom
        left
        :close-on-click="true"
        :close-on-content-click="false"
        :offset-y="false"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            :color="preset ? 'primary' : ''"
            icon
            v-on="on"
          >
            <v-icon>mdi-star</v-icon>
          </v-btn>
        </template>
        <v-toolbar flat dense :min-width="400" :max-width="500">
          <v-select
            v-model="preset"
            :items="presets"
            item-text="name"
            label="Presets"
            class="map-filter"
            validate-on-blur
            clearable
            return-object
            @change="presetChanged()"
          >
            <!-- <template v-slot:selection="{ index }">
              <span
                v-if="index === 0 && actionLayers && actionLayers.length"
                class="grey--text caption"
              >
                ({{ actionLayers.length }} Action Types)
              </span>
            </template> -->
          </v-select>
        </v-toolbar>
      </v-menu>
    </v-toolbar>
    <v-container fluid fill-height class="pa-0">
      <l-map
        id="map"
        ref="map"
        @ready="setMap()"
        :zoom.sync="zoom"
        :center="center"
        @update:center="centerUpdated"
        @update:bounds="boundsUpdated"
        :options="mapOptions"
      >
        <l-tile-layer :url="url" :attribution="attribution" />
        <l-control class="layer-control">
          <v-btn class="mb-2" fab small color @click="showLayers = !showLayers">
            <v-icon>mdi-layers</v-icon>
          </v-btn>
          <v-sheet
            light
            class="pa-4 pb-0"
            color="rgb(255, 255, 255, 0.7)"
            v-if="showLayers"
            key="mapLayers"
          >
            <div class="layer-switches">
              <v-switch
                dense
                class="my-0 py-0"
                v-model="actionMarkers"
                label="Action Markers"
                v-if="isActionsMapEnabled"
              ></v-switch>
              <v-switch
                dense
                class="my-0 py-0"
                v-model="groupGeoFence"
                label="Group Geofences"
              ></v-switch>
              <v-switch
                dense
                class="my-0 py-0"
                v-model="groupTooltip"
                label="Group Labels"
              ></v-switch>
            </div>
          </v-sheet>
        </l-control>
        <l-control v-if="hasAllDataLoaded" class="layer-control" key="geofenceSelectorShow">
          <v-btn
            class="mb-2"
            fab
            small
            color
            @click="showGeofenceSelector = !showGeofenceSelector"
          >
            <v-icon>mdi-hexagon-outline</v-icon>
          </v-btn>
          <v-sheet
            light
            class="pa-4 pb-0"
            color="rgb(0, 0, 0, 0.7)"
            v-show="showGeofenceSelector"
            key="showGeofenceSelector"
          >
            <span class="white--text title">Geofences</span>
            <v-virtual-scroll
              :items="geofences"
              :height="mapHeight - 150"
              min-width="300"
              item-height="30"
            >
              <template v-slot:default="{ item }">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="white--text subtitle-1" :title="item.name">{{item.name}}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-checkbox
                      v-model="item.show"
                      color="primary"
                      hide-details
                      @change="reRenderMap()"
                    ></v-checkbox>
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-virtual-scroll>
          </v-sheet>
        </l-control>
        <l-control class="layer-control" v-show="legendIcons && legendIcons.length" key="legendShow">
          <v-btn
            class="mb-2"
            fab
            small
            color
            @click="showLegend = !showLegend"
          >
            <v-icon>mdi-map-legend</v-icon>
          </v-btn>
          <v-sheet
            light
            class="pa-4 pb-0"
            color="rgb(0, 0, 0, 0.7)"
            v-show="showLegend"
            key="showMapLegend"
          >
            <span class="white--text title">Legend</span>
            <v-virtual-scroll
              :items="legendIcons"
              :height="mapHeight - 150"
              min-width="300"
              item-height="30"
            >
              <template v-slot:default="{ item }">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="white--text subtitle-1" :title="item.name">{{item.name}}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action><img height="25" :src="item.url" /></v-list-item-action>
                </v-list-item>
              </template>
            </v-virtual-scroll>
          </v-sheet>
        </l-control>
        <l-control class="zoom-control" position="topleft">
          <v-btn class="ml-2 mt-2" fab small color @click="zoomAction('in')">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-btn class="ml-2 mt-2" fab small color @click="zoomAction('out')">
            <v-icon>mdi-minus</v-icon>
          </v-btn>
          <v-list elevation="2" dense class="mt-2 rounded-lg new-message-panel" v-if="newMessages && newMessages.length" key="messageList">
            <v-list-item class="list-close">
              <v-list-item-action>
                <v-btn fab light x-small @click="newMessages = []">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-list-item two-line v-for="message in newMessages" :key="message.id">
              <v-list-item-content>
                <v-list-item-title>{{ message.action && message.action.name }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  message.created_at | date_time
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon @click="notifyClick(message)">
                  <v-icon color="grey lighten-1">mdi-information</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </l-control>
        <l-geo-json
          v-for="geofence in geofences"
          :key="geofence.id"
          :geojson="geofence.feature"
          :options="{ onEachFeature: onPolyFeature }"
          :visible="groupGeoFence && geofence.show !== false"
        ></l-geo-json>
        <l-marker
          v-for="message in mapMessages"
          :key="message.id"
          :lat-lng="getCoordinates(message.location)"
          :icon="messageIcon(message)"
          :visible="
            actionMarkers &&
            message &&
            message.properties.show_map_marker === true
          "
          @click="openMessagePopup(message)"
        ></l-marker>
        <l-feature-group ref="messageCard">
          <l-popup>
            <MessageCard
              :message="popupMessage"
              :action="openMessageCard"
              actionLabel="More"
            ></MessageCard>
          </l-popup>
        </l-feature-group>
      </l-map>
    </v-container>
    <v-toolbar class="mt-0">
      <div class="d-flex flex-row align-center justify-end mr-4 pt-1" v-if="actionMarkers && mapMessageCount">
        <v-btn color icon @click="showMoreMessages(50)" title="Load more" v-if="mapMessageLimit < mapMessageCount">
          <v-icon>mdi-more</v-icon>
        </v-btn>
        Showing {{mapMessageLimitDisplay}} of {{mapMessageCount}} messages
      </div>
    </v-toolbar>
    <Message :message.sync="cardMessage" :read-only="true"></Message>
    <pre>{{ mapMessages }}</pre>
  </section>
</template>

<script>
import { Icon, icon, latLng, geoJson } from "leaflet";
import {
  LMap,
  LControl,
  LTileLayer,
  LMarker,
  LPopup,
  LFeatureGroup,
  //LIcon,
  LGeoJson,
} from "vue2-leaflet";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import { makeFindMixin, makeGetMixin } from "feathers-vuex";
import MessageCard from "@/components/messages/MessageCard";
import Message from "@/components/messages/Message";

export default {
  components: {
    LMap,
    LControl,
    LTileLayer,
    LMarker,
    LPopup,
    LFeatureGroup,
    //LIcon,
    LGeoJson,
    MessageCard,
    Message,
  },
  data: () => ({
    map: null,
    actionLayers: [],
    legendIcons: [],
    legendWidth: 50,
    showLayers: false,
    showLegend: false,
    showGeofenceSelector: false,
    loadedOnce: false,
    actionMarkers: true,
    groupGeoFence: true,
    groupTooltip: false,
    zoom: 5.5,
    center: latLng(-28.4792625, 24.6727135),
    mapOptions: {
      minZoom: 5,
      zoomSnap: 0.5,
      zoomDelta: 0.5,
      zoomControl: false,
      wheelPxPerZoomLevel: 80,
    },
    icon: icon({
      iconUrl: require("@/assets/icons8-marker-24.png"),
      iconSize: [24, 24],
      iconAnchor: [12, 24],
    }),
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    showDetail: true,
    cardMessage: null,
    popupMessage: null,
    datePicker: null,
    dateFilter: moment().subtract(30, 'days').toISOString().substr(0, 10),
    enabledFeaturesConfigId: "enabledFeatures",
    messageIds: [],
    newMessages: [],
    mapMessageLimit: 50,
    mapMessageLimitBefore: 0,
    mapMessageCountBefore: 0,
    mapMessagesQID: null,
    presets: [
      { name: 'Vehicle Lookouts', query: { 
          action_id: 'aa6ae698-511c-4cf4-b6b1-aea587fb1ecf', 
          localFilter: { 'data.lookout': 'Vehicle' },
          fetchFilter: { data: { lookout: 'Vehicle' } }
        }
      },
      { name: 'Person Lookouts', query: { 
          action_id: 'aa6ae698-511c-4cf4-b6b1-aea587fb1ecf', 
          localFilter: { data: { lookout: 'Person' } },
          fetchFilter: { data: { lookout: 'Person' } }
        }
      }
    ],
    preset: null,
    localDataFilter: {},
    fetchDataFilter: {},
  }),
  created() {
    delete Icon.Default.prototype._getIconUrl;
    Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    });

    console.log(this.$route.params.bot, this.botApiUrl);
  },
  async mounted() {
    this.mapMessageLimitBefore = this.mapMessageLimit;
  },
  mixins: [
    makeFindMixin({ 
      service: "geofences",
      queryWhen: "fetchData",
    }),
    makeFindMixin({ 
      service: "actions",
      queryWhen: "fetchData",
    }),
    makeGetMixin({
      service: "configuration",
      name: "enabledFeat",
      id: "enabledFeaturesConfigId",
      queryWhen: "fetchData",
    }),
    makeFindMixin({
      service: "messages",
      name: "mapMessages",
      queryWhen: "fetchMessages",
      watch: true,
    }),
  ],
  computed: {
    ...mapGetters("config", ["botApiUrl"]),
    ...mapGetters("app", ["selectedBot"]),
    ...mapGetters("apiAuth", { isApiAuthenticated: "isAuthenticated" }),
    ...mapGetters("botAuth", { isBotAuthenticated: "isAuthenticated" }),
    botName() {
      return this.selectedBot && this.selectedBot.first_name;
    },
    fetchData() {
      return this.isApiAuthenticated && this.isBotAuthenticated;
    },
    isDataPending() {
      return this.isFindGeofencesPending || this.isFindActionsPending || this.isFindMapMessagesPending || this.isGetEnabledFeatPending;
    },
    hasAllDataLoaded() {
      return this.haveGeofencesLoadedOnce && this.haveActionsLoadedOnce && this.haveMapMessagesLoadedOnce && this.hasEnabledFeatLoadedOnce;
    },
    geofencesParams() {
      return {
        query: {
          $eager: "groups",
          $sort: {
            name: 1,
          },
        },
      };
    },
    actionsParams() {
      return {
        query: { 
          $limit: 50,
          $sort: {
            name: 1,
          },
          $eager: '[elaborator]'
        },
      };
    },
    mapMessagesParams() {
      let query = {
        action_id: {
          $in: this.actionLayers,
        },
        $limit: this.mapMessageLimit,
        $sort: {
          created_at: -1,
        },
        ...this.localDataFilter
      }

      if (!this.datePicker && this.dateFilter) {
        query.created_at = {
          $gte: this.dateFilter,
        };
      }

      return { query: query }
    },
    mapMessagesFetchParams() {
      let query = {
        action_id: {
          $in: this.actionLayers,
        },
        $limit: this.mapMessageLimit,
        $sort: {
          created_at: -1,
        },
        $eager: "[action.[elaborator]]",
        $modify: "mapMessage",
        ...this.fetchDataFilter
      }

      if (this.dateFilter) {
        query["messages.created_at"] = {
          $gte: this.dateFilter,
        };
      }

      return { query: query, debounce: 1000 }
    },
    isActionsMapEnabled() {
      return (
        this.enabledFeat &&
        this.enabledFeat.config &&
        this.enabledFeat.config.actions_map
      );
    },
    fetchMessages() {
      return this.isActionsMapEnabled && this.haveActionsLoadedOnce;
    },
    mapMessageCount() {
      return this.mapMessagesPaginationData && this.mapMessagesPaginationData.default && this.mapMessagesPaginationData.default.mostRecent && this.mapMessagesPaginationData.default.mostRecent.total
    },
    mapMessageLimitDisplay() {
      return this.mapMessageLimit <= this.mapMessageCount ? this.mapMessageLimit : this.mapMessageCount
    },
    mapHeight() {
      return this.map && this.map._size.y
    }
  },
  methods: {
    ...mapActions("apiAuth", ["authenticate"]),
    ...mapActions("app", ["showMessage"]),
    ...mapActions("config", ["apiUrlSet"]),
    innerClick() {
      alert("click");
    },
    presetChanged() {
      if (this.preset) {
        this.actionLayers = [this.preset.query.action_id];
        this.localDataFilter = this.preset.query.localFilter;
        this.fetchDataFilter = this.preset.query.fetchFilter;
      } else {
        this.actionLayers = this.actions.map((a) => a.id);
        this.localDataFilter = {};
        this.fetchDataFilter = {};
      }
    },
    addLegendIcon(name, icon) {
      const found = this.legendIcons.findIndex(icon => {
        return icon.name === name
      })

      if (found === -1) {
        this.legendIcons.push({ name: name, url: icon })

        this.legendIcons.sort((ia, ib) => ia.name < ib.name ? -1 : 1)
      }
    },
    messageIcon(message) {
      let iconUrl;
      const action = message.action;
      const selectIconsScenes = action && action.elaborator.scenes.filter((scene) => scene.options && scene.options.icons && scene.options.useIconsOnMap);

      if ((!action || !action.properties || !action.properties.iconUrl) && (!selectIconsScenes || !selectIconsScenes.length)) return;

      if (selectIconsScenes && selectIconsScenes.length) {
        selectIconsScenes.forEach((iScene) => {
          const selectIcons = iScene.options && iScene.options.icons;

          if (!iconUrl) {
            iconUrl = message.data && message.data[iScene.id] && selectIcons[message.data[iScene.id]]
            message.title = message.data[iScene.id]
            message.icon = iconUrl
            this.addLegendIcon(message.data[iScene.id], iconUrl)
          }
        });
      }

      if (!iconUrl) {
        iconUrl = action.properties && action.properties.iconUrl;
        this.addLegendIcon(action.name, iconUrl)
      }

      return icon({
        iconUrl: iconUrl,
        iconSize: [24, 24],
        iconAnchor: [12, 24],
      });
    },
    showMoreMessages(step) {
      let nextLimit = this.mapMessageLimit + step;
      this.mapMessageLimit = nextLimit <= this.mapMessageCount ? nextLimit : this.mapMessageCount;
    },
    setMap() {
      this.map = this.$refs.map.mapObject;
      this.setView();
    },
    setView() {
      if (this.geofences && this.geofences.length) {
        let geofencesFeatureCollection = {
          type: "FeatureCollection",
          features: this.geofences.map((geofence) => geofence.feature),
        };
        let geofencesGeoJson = geoJson(geofencesFeatureCollection);
        this.map.fitBounds(geofencesGeoJson.getBounds());
      }
    },
    reRenderMap() {
      this.map.invalidateSize();
    },
    zoomAction(how) {
      if (how === "in") this.map.zoomIn();
      if (how === "out") this.map.zoomOut();
    },
    centerUpdated() {},
    boundsUpdated() {
      this.showLayers = false;
    },
    messageCoordinates(message) {
      if (!message.location) return null;

      if (message.location.latitude && message.location.longitude) return message.location;
      /* if (!message.data) return null

      for (const key in message.data) {
        if (Object.hasOwnProperty.call(message.data, key)) {
          const element = message.data[key]
          
          if (element.latitude && element.longitude) return element
        }
      } */

      return null
    },
    getCoordinates(location) {
      if (!location) return null;
      return latLng(location.latitude, location.longitude);
    },
    openMessagePopup(message) {
      this.popupMessage = message;
      this.$refs.messageCard.mapObject.openPopup(
        this.getCoordinates(message.location)
      );
    },
    openMessageCard(message) {
      this.cardMessage = message;
    },
    onPolyFeature(feature, layer) {
      let style = {};

      if (feature.properties) {
        style = { ...feature.properties };
        if (style.fill && !style.color) {
          style.color = style.fill;
          style.fillColor = style.fill;
        }
        if (style["fill-opacity"]) style.fillOpacity = style["fill-opacity"];
      }

      layer.bindTooltip(
        function (layer) {
          let groups = [];
          layer.options.groups.forEach((group) => {
            groups.push(group.title);
          });
          return groups.length
            ? `${layer.options.name}: ${groups.join(", ")}`
            : layer.options.name;
        },
        { permanent: this.groupTooltip, opacity: 0.7 }
      );
      layer.setStyle(style);
    },
    notifyNewMessage(messages) {
      messages.forEach((message) => {
        if (!this.messageIds.includes(message.id) && message.properties.show_map_marker) {
          this.messageIds.push(message.id);
          this.newMessages.push(message);

          this.showMessage({
            text: "New message on map",
            position: "top",
            color: "primary"
          });
        }
      });
    },
    notifyClick(message) {
      const coordinates = this.messageCoordinates(message);

      if (!coordinates) return null;

      const latLngs = this.getCoordinates(coordinates);

      this.popupMessage = message;
      this.$refs.messageCard.mapObject.openPopup(latLngs);

      setTimeout(() => {
        const newMsgIndex = this.newMessages.findIndex(msg => msg.id === message.id);

        this.map.flyTo(latLngs, 17, {
          animate: true,
          duration: 1.5,
        });
        this.newMessages.splice(newMsgIndex, 1);
      }, 1000);
    },
  },
  watch: {
    fetchData(fetch) {
      if (fetch) {
        console.log("Fetching data...");
        this.findGeofences();
        this.findActions();
        this.getEnabledFeat();
      }
    },
    hasAllDataLoaded(loaded) {
      if (loaded) {
        this.reRenderMap();
      }
    },
    geofences(geofences) {
      if (geofences && geofences.length) {
        this.setView();
      }
    },
    haveGeofencesLoadedOnce(loaded) {
      if (loaded) {
        this.geofences.forEach((geofence) => {
          geofence.show = true;
        });
      }
    },
    haveMapMessagesLoadedOnce(loaded) {
      if (loaded) {
        this.messageIds = this.mapMessages.map((message) => message.id);
      }
    },
    haveActionsLoadedOnce(loaded) {
      if (loaded) {
        this.actionLayers = this.actions.map((a) => a.id);
      }
    },
    mapMessageLimit(now) {
      setTimeout(() => {
        this.mapMessageLimitBefore = now;
      }, 5000);
    },
    async mapMessages(now) {
      if (this.mapMessageCountBefore === 0) this.mapMessageCountBefore = this.mapMessageCount;

      if (
        this.isActionsMapEnabled &&
        this.haveMapMessagesLoadedOnce
      ) {
        this.legendIcons = [];
        await this.findMapMessages();

        if (this.mapMessageCountBefore !== this.mapMessageCount) {
          this.notifyNewMessage(now);
          this.mapMessageCountBefore = this.mapMessageCount
        } else {
          now.forEach((message) => {
            if (!this.messageIds.includes(message.id)) {
              this.messageIds.push(message.id);
            }
          })
        }
      }
    },
    isActionsMapEnabled(enabled) {
      if (enabled && !this.mapMessages.length) this.findMapMessages();
    }
  },
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~leaflet/dist/leaflet.css";

#map {
  height: 70vh;

  .layer-control {
    text-align: right;
  }

  .legend-sheet {
    width: fit-content;
  }

  .new-message-panel {
    opacity: 0.9;

    .list-close {
      position: absolute;
      right: -60px;
      top: 20px;
    }
  }
}

.step-field {
  width: 115px;
}

.v-menu__content {
  z-index: 1000 !important;
}

.leaflet-popup-pane {
  .leaflet-popup {
    margin-bottom: 35px;
    margin-left: 0px;

    .leaflet-popup-content-wrapper {
      background: transparent;
      box-shadow: none;

      .leaflet-popup-content {
        margin: 0;
      }
    }
  }
}
</style>